import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ChatInterface } from '@/components/chat/ChatInterface';

export function ChatPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const sessionId = searchParams.get('session');

  const handleSessionChange = useCallback(
    (newSessionId: string | null) => {
      if (newSessionId) {
        if (newSessionId !== sessionId) {
          setSearchParams({ session: newSessionId }, { replace: true });
        }
      } else {
        setSearchParams({}, { replace: true });
      }
    },
    [sessionId, setSearchParams]
  );

  return (
    <div className="flex h-screen flex-col">
      <ChatInterface
        className="flex-1"
        initialSessionId={sessionId}
        onSessionChange={handleSessionChange}
      />
    </div>
  );
}
